/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Spry_Beetle_TasteInputs */

const fr_legal_spry_beetle_taste = /** @type {(inputs: Legal_Spry_Beetle_TasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon Profil`)
};

/**

* @param {Legal_Spry_Beetle_TasteInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const legal_spry_beetle_taste = /** @type {((inputs?: Legal_Spry_Beetle_TasteInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Spry_Beetle_TasteInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_legal_spry_beetle_taste(inputs)
});